import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Legalpage.css';

const SECTIONS = [
  { id: 'editeur',        num: '01', label: 'Éditeur du site' },
  { id: 'hebergement',    num: '02', label: 'Hébergement' },
  { id: 'propriete',      num: '03', label: 'Propriété intellectuelle' },
  { id: 'responsabilite', num: '04', label: 'Responsabilité' },
  { id: 'donnees',        num: '05', label: 'Données personnelles' },
  { id: 'cookies',        num: '06', label: 'Cookies' },
  { id: 'droit',          num: '07', label: 'Droit applicable' },
];

export default function MentionsLegales() {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="legal">

        <div className="legal__hero">
          <div className="legal__hero-inner container">
            <button className="legal__back" onClick={() => navigate(-1)} type="button">
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M19 12H5M12 5l-7 7 7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Retour
            </button>
            <h1 className="legal__title">Mentions légales</h1>
            <p className="legal__subtitle">Mise à jour le 25 mars 2026</p>
          </div>
        </div>

        <div className="legal__body">
          <div className="container">
            <div className="legal__grid">

              <aside className="legal__toc">
                <p className="legal__toc-title">Sommaire</p>
                <ul className="legal__toc-list">
                  {SECTIONS.map(s => (
                    <li key={s.id}>
                      <a href={`#${s.id}`} className="legal__toc-link">{s.label}</a>
                    </li>
                  ))}
                </ul>
              </aside>

              <main className="legal__content">

                <section id="editeur" className="legal__section">
                  <span className="legal__section-num">01</span>
                  <h2 className="legal__section-title">Éditeur du site</h2>
                  <p>Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance en l'Économie Numérique (LCEN), le présent site est édité par :</p>
                  <table className="legal__table">
                    <tbody>
                      <tr><th>Raison sociale</th><td>SOCLIMATE</td></tr>
                      <tr><th>Forme juridique</th><td>Société par actions simplifiée (SAS)</td></tr>
                      <tr><th>SIREN</th><td>991 881 194</td></tr>
                      <tr><th>SIRET (siège social)</th><td>991 881 194 00013</td></tr>
                      <tr><th>N° TVA intracommunautaire</th><td>FR08991881194</td></tr>
                      <tr><th>Code NAF / APE</th><td>4322A — Travaux d'installation d'eau et de gaz en tous locaux</td></tr>
                      <tr><th>Date de création</th><td>1er octobre 2025</td></tr>
                      <tr><th>Siège social</th><td>1 rue de Belloy, 95570 Villaines-sous-Bois</td></tr>
                      <tr><th>Dirigeant</th><td>Isaac ERRAJI</td></tr>
                      <tr><th>Contact</th><td>contact@soclimate.fr</td></tr>
                    </tbody>
                  </table>
                </section>

                <section id="hebergement" className="legal__section">
                  <span className="legal__section-num">02</span>
                  <h2 className="legal__section-title">Hébergement</h2>
                  <p>Le site est hébergé par un prestataire dont les coordonnées sont disponibles sur demande auprès de SOCLIMATE. En cas de question relative à l'hébergement, vous pouvez contacter directement la société éditrice à l'adresse mentionnée ci-dessus.</p>
                </section>

                <section id="propriete" className="legal__section">
                  <span className="legal__section-num">03</span>
                  <h2 className="legal__section-title">Propriété intellectuelle</h2>
                  <p>L'ensemble des contenus présents sur ce site (textes, images, graphismes, logos, icônes, sons, logiciels…) est la propriété exclusive de SOCLIMATE ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.</p>
                  <p>Toute reproduction, représentation, modification, publication ou transmission de tout ou partie du site, sans autorisation préalable et écrite de SOCLIMATE, est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.</p>
                </section>

                <section id="responsabilite" className="legal__section">
                  <span className="legal__section-num">04</span>
                  <h2 className="legal__section-title">Limitation de responsabilité</h2>
                  <p>SOCLIMATE s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, SOCLIMATE ne peut garantir l'exhaustivité des informations mises à disposition.</p>
                  <p>En conséquence, SOCLIMATE décline toute responsabilité :</p>
                  <ul>
                    <li>pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site ;</li>
                    <li>pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ;</li>
                    <li>pour tout dommage causé par la consultation du site ou par tout élément qui y est accessible.</li>
                  </ul>
                </section>

                <section id="donnees" className="legal__section">
                  <span className="legal__section-num">05</span>
                  <h2 className="legal__section-title">Données personnelles</h2>
                  <p>Les informations recueillies sur ce site sont destinées exclusivement à SOCLIMATE pour le traitement de vos demandes. Elles ne sont en aucun cas cédées à des tiers.</p>
                  <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
                  <ul>
                    <li>Droit d'accès, de rectification et d'effacement de vos données ;</li>
                    <li>Droit à la limitation du traitement et à la portabilité ;</li>
                    <li>Droit d'opposition au traitement ;</li>
                    <li>Droit d'introduire une réclamation auprès de la CNIL.</li>
                  </ul>
                  <p>Pour exercer ces droits : <strong style={{ color: 'rgba(255,255,255,0.78)' }}>contact@soclimate.fr</strong> — 1 rue de Belloy, 95570 Villaines-sous-Bois.</p>
                </section>

                <section id="cookies" className="legal__section">
                  <span className="legal__section-num">06</span>
                  <h2 className="legal__section-title">Cookies</h2>
                  <p>Ce site est susceptible d'utiliser des cookies techniques nécessaires à son bon fonctionnement. Ils ne collectent aucune information personnelle à des fins publicitaires ou de profilage.</p>
                  <p>Votre consentement est recueilli avant tout dépôt de cookie non strictement nécessaire. Vous pouvez modifier vos préférences via les paramètres de votre navigateur.</p>
                  <div className="legal__info-box">
                    <p>Pour en savoir plus sur la gestion des cookies : <strong style={{ color: 'rgba(255,255,255,0.72)' }}>www.cnil.fr</strong></p>
                  </div>
                </section>

                <section id="droit" className="legal__section">
                  <span className="legal__section-num">07</span>
                  <h2 className="legal__section-title">Droit applicable et juridiction</h2>
                  <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.</p>
                  <p>Toute réclamation doit être adressée à SOCLIMATE, 1 rue de Belloy, 95570 Villaines-sous-Bois, ou par email à contact@soclimate.fr.</p>
                </section>

              </main>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}